export const enhanceWithCache = <T, U extends Array<T>, V>(
  fn: (...args: U) => V,
  keyFn: (...args: U) => string
): ((...args: U) => V) => {
  const cache: { [key: string]: V } = {};
  return (...args: U): V => {
    const key = keyFn(...args);
    if (!cache[key]) {
      cache[key] = fn(...args);
    }
    return cache[key];
  };
};
